import { GET_PICK_AND_DROP_SETTINGS } from "./actionTypes";

const initialState = {
    pickupDropSettings: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_PICK_AND_DROP_SETTINGS:
            return { ...state, pickupDropSettings: action.payload };
        default:
            return state;
    }
}
